import { InboxOutlined } from '@ant-design/icons'
import { message, Upload } from '@pankod/refine-antd'
import React, { useState } from 'react'

const { Dragger } = Upload

interface Props {
  setReferenceTextDetails: React.Dispatch<React.SetStateAction<string>>
  apiEndPoint: string
  showText: string
}

const ReferenceFileUpload: React.FC<Props> = ({ setReferenceTextDetails, apiEndPoint, showText }) => {
  const [fileList, setFileList] = useState<any[]>([])

  const referenceProps = {
    name: 'reference_file',
    multiple: false,
    action: `${process.env.REACT_APP_BACKEND_URL}/${apiEndPoint}`,
    // action: `http://localhost:3001/${apiEndPoint}`,
    accept: '.pdf, image/*',
    fileList: fileList,
    onChange(info: any) {
      if (info.fileList.length === 0) {
        setFileList([])
        setReferenceTextDetails('')
        return
      }
    //last file from the file list the current uploading file
      const file = info.fileList[info.fileList.length - 1]
      setReferenceTextDetails('')
      if (file.status === 'done') {
        if (file.response && file.response.reference) {
          setReferenceTextDetails(file.response.reference)
          message.success('Uploaded successfully')
        } else if (file.response && file.response.message) {
          message.error(file.response.message || 'Unable to extract the text from uploaded file...')
        }
      }

      // Update the fileList state with the new file
      setFileList(info.fileList.slice(-1))
    },
    onDrop(e: any) {
      console.log(e.dataTransfer.files, 'dropped files')
    },
  }
  return (
    <div>
      <Dragger style={{ marginBottom: '1rem' }} {...referenceProps}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">{showText}</p>
      </Dragger>
    </div>
  )
}

export default ReferenceFileUpload
